/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { IAccountWishlistTileViewProps } from '@msdyn365-commerce-modules/account-management/src/modules/account-wishlist-tile/./account-wishlist-tile';
import { format, Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IAccountWishlistTileProps } from '../definition-extensions/account-wishlist-tile.ext.props.autogenerated';

const AccountWishlistTileView: React.FC<IAccountWishlistTileViewProps & IAccountWishlistTileProps<{}>> = props => {
    const { AccountWishlistTile, heading, links } = props;
    const wishlists = props.data.wishlists.result;

    /* VSI-Customization -- START Render description based on count  */
    const renderDescription = () => {
        const wishlistsCount = ((wishlists && wishlists.length && wishlists[0].CommerceListLines) || []).length;
        let descp = '';
        if (wishlistsCount === 1) {
            descp = format(props.resources.accountWishlistSingleTileDescription, wishlistsCount);
        } else {
            descp = format(props.resources.accountWishlistTileDescription, wishlistsCount);
        }
        return (
            <Node tag='p' className='ms-account-wishlist-tile__description'>
                {descp}
            </Node>
        );
    };
    /* VSI-Customization -- END  */

    return (
        <Module {...AccountWishlistTile}>
            {heading}
            {renderDescription()}
            {links}
        </Module>
    );
};

export default AccountWishlistTileView;
